module.exports = __webpack_public_path__ + "img/economy.77bf3ee5.png";